import { Component, Input, Output, inject, OnInit, signal, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { EventEmitter } from '@angular/core';
import { ViewNewRepApplication } from '../../new-rep-application-interfaces/viewnew-rep-application.interface';

@Component({
  selector: 'app-branch-details',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    // MatIcon
  ],
  templateUrl: './branch-details.components.html',
  styleUrl: './branch-details.components.scss'
})
export class BranchDetailsComponents implements OnInit {

  @Input() formGroup!: FormGroup;
  @Input() branchdetails!: ViewNewRepApplication;
  @Output() next = new EventEmitter<string[]>();
  private fb = inject(FormBuilder);
  status = 'Not Started';
  async ngOnInit() {

    this.formGroup.addControl('branchName', this.fb.control(''));
    this.formGroup.addControl('fsd', this.fb.control(''));
    this.formGroup.addControl('fsm', this.fb.control(''));

    await this.fetchBranchDetails();
  }

  fetchBranchDetails(): void {
    this.formGroup.controls['branchName']?.setValue(this.branchdetails?.branch);
    this.formGroup.controls['fsd']?.setValue(this.branchdetails?.finacialServiceDir);
    this.formGroup.controls['fsm']?.setValue(this.branchdetails?.finacialServiceMan);
    this.status = 'Completed';
    this.next.emit([this.status, 'submit']);
    this.formGroup?.disable();
  }

  saveAndContinue() {
    // let status: number;
    // Save API call or form validation here
    if (this.formGroup.valid) {
      this.status = 'Completed';

    }
    this.next.emit([this.status, 'submit']);
  }

}
